import { motion, AnimatePresence } from 'framer-motion';
import { Pin, PinOff } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

const formatTime = (dateString) => {
  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);
  
  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins}m`;
  if (diffHours < 24) return `${diffHours}h`;
  if (diffDays < 7) return `${diffDays}d`;
  return date.toLocaleDateString();
};

export const PinnedMessagesPanel = ({
  show,
  pinnedMessages,
  onClose,
  onUnpinMessage
}) => {
  const { t } = useLanguage();

  return (
    <AnimatePresence>
      {show && pinnedMessages.length > 0 && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: 'auto', opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          className="bg-amber-500/10 border-b border-amber-500/20 overflow-hidden"
        >
          <div className="p-3">
            <div className="flex items-center justify-between mb-2">
              <span className="text-xs font-medium text-amber-400 flex items-center gap-1">
                <Pin className="w-3 h-3" /> {t('pinned_messages')} ({pinnedMessages.length})
              </span>
              <button
                onClick={onClose}
                className="text-slate-400 hover:text-white text-xs"
              >
                {t('close')}
              </button>
            </div>
            <div className="space-y-2 max-h-40 overflow-y-auto">
              {pinnedMessages.map((msg) => (
                <div
                  key={msg.message_id}
                  className="bg-slate-800/50 rounded-lg p-2 flex items-start justify-between gap-2"
                >
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1">
                      <span className="text-xs font-medium text-slate-300">{msg.sender_name}</span>
                      <span className="text-xs text-slate-500">{formatTime(msg.created_at)}</span>
                    </div>
                    <p className="text-sm text-slate-300 line-clamp-2">{msg.content}</p>
                  </div>
                  <button
                    onClick={() => onUnpinMessage(msg.message_id)}
                    className="p-1 rounded hover:bg-slate-700 text-slate-400 hover:text-amber-400"
                  >
                    <PinOff className="w-3 h-3" />
                  </button>
                </div>
              ))}
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default PinnedMessagesPanel;
